import type { NavigateFunction } from "react-router-dom";

import { ROUTESWEB } from "@repo/utils";

const STORAGE_KEY = "doubts_return_aina_agent_v1";

/** DC `createDoubt.source` when the doubt is created from the AINA host flow. */
export const CREATE_DOUBT_SOURCE_AINA = "AINA" as const;
/** DC `createDoubt.source` for the standard doubts product entry. */
export const CREATE_DOUBT_SOURCE_DOUBTS = "DOUBTS" as const;

export type CreateDoubtSourceChannel =
  | typeof CREATE_DOUBT_SOURCE_AINA
  | typeof CREATE_DOUBT_SOURCE_DOUBTS;

export function setAinaReturnAgentForDoubtsChat(agent: string): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, agent.trim());
}

/** Read pending return without consuming (for UI that should only show after AINA → doubts). */
export function peekAinaReturnAgentForDoubtsChat(): string | null {
  if (typeof sessionStorage === "undefined") return null;
  const raw = sessionStorage.getItem(STORAGE_KEY);
  const trimmed = raw?.trim();
  return trimmed ? trimmed : null;
}

/** Resolves `createDoubt.source` for Ask Questions when the AINA return agent is set (sessionStorage). */
export function createDoubtSourceWhenAinaAgentPresent(): CreateDoubtSourceChannel {
  return peekAinaReturnAgentForDoubtsChat() != null
    ? CREATE_DOUBT_SOURCE_AINA
    : CREATE_DOUBT_SOURCE_DOUBTS;
}

export function tryReturnToAinaFromDoubtsChat(
  navigate: NavigateFunction,
): boolean {
  if (typeof sessionStorage === "undefined") return false;
  const raw = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  const agent = raw?.trim();
  if (!agent) return false;
  /** Do not call `setAinaReturnPathFromWindowLocation` here: window is still on `/doubts/…` and would overwrite `aina_return_path_v1` from the original AINA open (e.g. home). Parity with RN `openAinaScreen(..., { preserveReturnSnapshot: true })`. */
  const path =
    agent === "AINA_MENTOR"
      ? `/${ROUTESWEB.APP.AINA_MENTOR}`
      : `/${ROUTESWEB.APP.AINA_VOICE}`;
  navigate(path);
  return true;
}

/** Clears pending return (e.g. when leaving /doubts without completing chat). */
export function clearAinaReturnAgentForDoubtsChat(): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY);
}
